export const PLANS = [
  {
    name: ["D", "development"],
    includes: [["project.plan.includes.branch"]]
  },
  {
    name: ["small"],
    includes: [
      ["project.plan.includes.additional_service", { value: 1 }],
      ["project.plan.includes.production_site"],
      ["project.plan.includes.custom_domains"],
      ["project.plan.includes.ssl"]
    ]
  },
  {
    name: ["essential"],
    defaults: [["project.plan.includes.envs", { value: 1 }]],
    includes: [
      ["project.plan.specs", { cpu: 0.65, memory: 0.65 }],
      ["project.plan.includes.additional_service", { value: 1 }],
      ["project.plan.includes.production_site"],
      ["project.plan.includes.custom_domain"],
      ["project.plan.includes.ssl"]
    ]
  },
  {
    name: ["S", "standard"],
    includes: [
      ["project.plan.specs", { cpu: 1, memory: 0.8 }],
      ["project.plan.traffic.low_med_traffic_websites"]
    ]
  },
  {
    name: ["high-mem/standard", "standard-high-memory"],
    includes: [
      ["project.plan.specs", { cpu: 1, memory: 2 }],
      ["project.plan.traffic.low_med_traffic_websites"]
    ]
  },
  {
    name: ["M", "medium"],
    includes: [
      ["project.plan.specs", { cpu: 2, memory: 3 }],
      ["project.plan.traffic.med_higher_traffic_websites"],
      ["project.plan.multi_app_multi_data_apps"]
    ]
  },
  {
    name: ["high-mem/medium", "medium-high-memory"],
    includes: [
      ["project.plan.specs", { cpu: 2, memory: 4 }],
      ["project.plan.traffic.med_higher_traffic_websites"],
      ["project.plan.multi_app_multi_data_apps"]
    ]
  },
  {
    name: ["L", "large"],
    includes: [
      ["project.plan.specs", { cpu: 4, memory: 6 }],
      ["project.plan.traffic.higher_traffic_websites"],
      ["project.plan.multiple_backends"],
      ["project.plan.complex_micro_service_applications"]
    ]
  },
  {
    name: ["high-mem/large", "large-high-memory"],
    includes: [
      ["project.plan.specs", { cpu: 4, memory: 8 }],
      ["project.plan.traffic.higher_traffic_websites"],
      ["project.plan.multiple_backends"],
      ["project.plan.complex_micro_service_applications"]
    ]
  },
  {
    name: ["XL", "xlarge"],
    includes: [
      ["project.plan.specs", { cpu: 8, memory: 12 }],
      ["project.plan.traffic.higher_traffic_websites"],
      ["project.plan.multiple_backends"],
      ["project.plan.memory_intensive_apps"],
      ["project.plan.complex_micro_service_applications"]
    ]
  },
  {
    name: ["high-mem/xlarge", "xlarge-high-memory"],
    includes: [
      ["project.plan.specs", { cpu: 8, memory: 16 }],
      ["project.plan.traffic.higher_traffic_websites"],
      ["project.plan.multiple_backends"],
      ["project.plan.memory_intensive_apps"],
      ["project.plan.complex_micro_service_applications"]
    ]
  },
  {
    name: ["XXL", "2xlarge"],
    includes: [
      ["project.plan.specs", { cpu: 16, memory: 24 }],
      ["project.plan.traffic.higher_traffic_websites"],
      ["project.plan.multiple_backends"],
      ["project.plan.memory_intensive_apps"],
      ["project.plan.complex_micro_service_applications"]
    ]
  },
  {
    name: ["high-mem/2xlarge", "2xlarge-high-memory"],
    includes: [
      ["project.plan.specs", { cpu: 16, memory: 32 }],
      ["project.plan.traffic.higher_traffic_websites"],
      ["project.plan.multiple_backends"],
      ["project.plan.memory_intensive_apps"],
      ["project.plan.complex_micro_service_applications"]
    ]
  }
] as const;
